import React, { useState } from 'react';
import { Divider, Space, Typography, Row, Col, Input, Button } from 'antd';
import { EditOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';

// Utility function to generate consistent colors
const generateColor = (index) => {
    const colors = [
        '#0A497B', // Deep Blue
        '#1890FF', // Bright Blue
        '#52C41A', // Green
        '#FA8C16', // Orange
    ];
    return colors[index % colors.length];
};
const InformationSection = ({
    title,
    fields,
    fullWidth = false,
    icon = null
}) => {
    const [editingField, setEditingField] = useState(null);
    const [editValue, setEditValue] = useState('');

    const handleEdit = (field) => {
        setEditingField(field.label);
        setEditValue(field.value || '');
    };

    const handleSave = (field) => {
        if (field.onSave) {
            field.onSave(editValue);
        }
        setEditingField(null);
    };

    const handleCancel = () => {
        setEditingField(null);
    };

    return (
        <>
            <Divider orientation="left">
                <Space>
                    {icon}
                    <Typography.Text strong style={{ fontSize: '18px' }}>
                        {title}
                    </Typography.Text>
                </Space>
            </Divider>
            <Row gutter={16}>
                {fields.map((field, index) => (
                    <Col
                        xs={24}
                        md={fullWidth ? 24 : 6}
                        key={field.label}
                    >
                        <Space align="center">
                            <Typography.Text
                                style={{
                                    color: generateColor(index),
                                    fontSize: "18px",
                                }}
                            >
                                {field.label}:
                            </Typography.Text>
                            {field.editable && editingField !== field.label && (
                                <Button
                                    type="link"
                                    icon={<EditOutlined />}
                                    onClick={() => handleEdit(field)}
                                    size="small"
                                />
                            )}
                        </Space>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {editingField === field.label ? (
                                <>
                                    <Input
                                        value={editValue}
                                        onChange={(e) => setEditValue(e.target.value)}
                                        onPressEnter={() => handleSave(field)}
                                        style={{ marginRight: '8px' }}
                                    />
                                    <Button
                                        type="primary"
                                        icon={<SaveOutlined />}
                                        onClick={() => handleSave(field)}
                                        size="small"
                                        style={{ marginRight: '4px' }}
                                    />
                                    <Button
                                        icon={<CloseOutlined />}
                                        onClick={handleCancel}
                                        size="small"
                                    />
                                </>
                            ) : (
                                <Typography.Paragraph>
                                    {field.value || "-"}
                                </Typography.Paragraph>
                            )}
                        </div>
                    </Col>
                ))}
            </Row>
        </>
    );
};

export default InformationSection;